const indexPriority = {
    negative: -5,
    none: 0,
    xSmall: 1,
    small: 3,
    normal: 4,
    medium: 10,
    high: 20,
    xHigh: 30,
    ultra: 50,
    enormous: 100,
    tremendous: 200,
    titanic: 500,
    max: 1000,
    // New layers for proper stacking
    dropdown: 2000,
    modal: 5000,
    modalBackdrop: 4999,
    collapse: 6000,
    collapseBackdrop: 19,
    toast: 8000,
    // 3DS Challenge layers
    threeDSBackdrop: 9998,
    threeDS: 9999
}

export default indexPriority;
